var render = function render(){var _vm=this,_c=_vm._self._c;return _c('PublicLayout',{attrs:{"id":"app-auth"}},[_c('Logo',{staticClass:"align-items-center my-2 my-md-5 my-lg-7"}),_c('ForgotPasswordForm'),_c('CertifiedLogos',{staticClass:"certified-logos my-5 py-5 flex-column"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }